import { FC } from 'react';

import { PopoverTrigger } from '@radix-ui/react-popover';

import { twMerge } from 'tailwind-merge';

import { pixelShapeOvalsImage } from '@/shared/assets';

import { useViewportStore } from '../../../lib';
import { Button } from '../../button';
import { Dialog, DialogContent, DialogTrigger } from '../../dialog';
import { Drawer, DrawerContent, DrawerTrigger } from '../../drawer';
import { Popover, PopoverContent } from '../../popover';
import { ISupportContent, TSupportPopover } from './types';

const SupportContent: FC<ISupportContent> = ({ closeSupport }) => (
  <div className="flex flex-col items-center gap-6 md:gap-5 md:p-5">
    <img
      src={pixelShapeOvalsImage}
      alt=""
      className="mt-10 h-[98px] w-[120px] md:m-0"
    />
    <div className="px-10 md:p-0">
      <h2 className="mx-auto max-w-[287px] px-10 text-center font-black heading-m md:mx-0 md:max-w-full md:p-0 md:text-left">
        We are here to help
      </h2>
      <p className="mx-auto mt-3 max-w-[273px] self-stretch text-center text-[16px] font-medium leading-6 md:mx-0 md:max-w-full md:text-left">
        Wow... We&apos;re closer now — we will respond within 3 days!
      </p>
    </div>
    <div className="!w-full px-5 pb-5 md:p-0">
      <a href="mailto:info@fcb.tm" className="w-full">
        <Button
          size="2xl"
          variant="dark-gray"
          className="!w-full rounded-[50px] text-center leading-[22px]"
          onClick={closeSupport}
        >
          Email
        </Button>
      </a>
    </div>
  </div>
);

export const SupportPopover: FC<TSupportPopover> = ({
  isOpen,
  onOpenChange,
  isModal,
  className,
  children,
}) => {
  const { isMobile } = useViewportStore();

  const closeSupportHandler = () => {
    onOpenChange(false);
  };

  if (isMobile)
    return (
      <Drawer open={isOpen} onOpenChange={onOpenChange}>
        <DrawerTrigger asChild>{children}</DrawerTrigger>
        <DrawerContent
          closeButton={null}
          className={twMerge(
            'bottom-1 mx-1 gap-5 rounded-3xl bg-base-500 p-0',
            className,
          )}
        >
          <SupportContent closeSupport={closeSupportHandler} />
        </DrawerContent>
      </Drawer>
    );
  if (isModal)
    return (
      <Dialog open={isOpen} onOpenChange={onOpenChange}>
        <DialogTrigger asChild>{children}</DialogTrigger>
        <DialogContent>
          <SupportContent closeSupport={closeSupportHandler} />
        </DialogContent>
      </Dialog>
    );
  return (
    <Popover open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        className={twMerge(
          'z-20 mb-3 mr-5 w-full max-w-[280px] rounded-[28px] bg-base-500 p-0 text-white',
          className,
        )}
      >
        <SupportContent closeSupport={closeSupportHandler} />
      </PopoverContent>
    </Popover>
  );
};
